export default "__VITE_ASSET__jZ00c3Xs__"